import React from 'react';
import __ from "../../../i18n";
import InlineEditButton from "../components/inline-edit-button/InlineEditButton";
import NotSetIndicator from "../../../../bootstrap/components/not-set-indicator/NotSetIndicator";


function getColumnConfigs({updateItem, refreshData, refs}) {
    return [
        {
            key: 'id',
            name: __('ID'),
            sortable: true
        },
        {
            key: 'name',
            name: __('Name'),
            sortable: true,
            renderValue: (value, item) => {
                return <>
                    <p>{value}</p>
                    <p>
                        <InlineEditButton
                            item={item}
                            refs={refs}
                            onDone={(values) => refreshData()}
                        />
                    </p>
                </>;
            }
        },
    ];
}

export default {
    getColumnConfigs
};
